import { render, staticRenderFns } from "./IssuesList.vue?vue&type=template&id=1757d1a3&scoped=true"
import script from "./IssuesList.vue?vue&type=script&lang=js"
export * from "./IssuesList.vue?vue&type=script&lang=js"
import style0 from "./IssuesList.vue?vue&type=style&index=0&id=1757d1a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1757d1a3",
  null
  
)

export default component.exports